import React from 'react';

import NavItems from '../NavItems/NavItems';
import classes from './SideDrawer.css';
import BackDrop from '../../UI/backdrop/Backdrop';
import Aux from '../../../hoc/Aux'

const SideDrawer=(props)=>{
	let attachedClasses=`${classes.SideDrawer} ${classes.Close}`;
	if(props.show){

		attachedClasses=`${classes.SideDrawer} ${classes.Open}`;
	}

	return (
		<Aux>
		<BackDrop show={props.show} click={props.click}/>
		<div className={attachedClasses} onClick ={props.click}>
			<nav >
				<NavItems isAuth ={props.isAuth}/>
			</nav>	
		</div>
		</Aux>
		)

}

export default SideDrawer;



// WEBPACK FOOTER //
// ./src/components/Navigation/Sidedrawer/SideDrawer.jsx